import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosIntance from '../../helper/axios'
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import {baseUrl} from '../../config';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

function MidBaselines() {
  const [selectedRow, setSelectedRow] = useState(null);
  const history = useHistory();
  checkUserTypeFn(history);

function checkUserTypeFn(history){
  const userdata=JSON.parse(sessionStorage.getItem('userdata'));
  const usertype=userdata.type;
  console.log('in check usertype fn');
  console.log(usertype)
  if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='databasehelper'){
    history.push('/');
 }

}
  const handleSignOut = () => {
    window.sessionStorage.setItem('isLogin',false);
    history.push('/');
  }

  if(sessionStorage.getItem('isLogin')==="false" || sessionStorage.getItem('isLogin')==null){
    history.push('/');
  }

  const [midData,setMidData]=useState([])
  
  const [message, setMessage] = useState('')
  const data = [['attribute', 'attribute2'], ['value1', 'value2']];
  const [successMsg,setSuccessMsg]=useState('')
  useEffect(() => {
    axiosIntance.get(baseUrl+'/midbaselines', {}).then(response => {

      console.log(response.data.result)
      console.log(response.data.result.length)
      if (response.data.result.length > 0) {
        console.log('data we have')
        setMidData(response.data.result);
        console.log(response.data.result)


      } else {
        //setMessage('No data');
        console.log(45)
       // history.push('/home');
      }

    }).catch(error => {
      setMessage('Something went wrong');
    });


    return () => {
      console.log('un subscribe')
    }



  }, [])
 

  const SubmitDelete = (e) => {

    confirmAlert({
      title: '',
      message: 'Are you sure want to delete All data',
      buttons: [
        {
          label: 'Yes',
          onClick: () => 
          axiosIntance.delete(baseUrl+'/midbaselines', {}).then(response => {
            setSuccessMsg('Deleted!')
            //setTimeout(()=>window.location.href = '/viewMidBaselines',2000)
          }).catch(error => {
            setMessage('Something went wrong');
          })

        },
        {
          label: 'No',
          onClick: () => console.log('No')
        }
      ]
    });
  }
 
  return (

    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />

    <div className='delete-div'>
      {
        midData.length>0 ? <button type="button"  onClick={SubmitDelete} className="btn btn-primary">Delete All </button>:''
       
      }
     
    </div>
    <div className='errorMsg'>{message}</div>
    <div className='successMsg viewScreen'>{successMsg}</div>




  


      <section id="content-wrapper">
        <MaterialTable
          columns={[
            { title: "Gateway", field: "gateway" },
            { title: "Decline Percent", field: "decline_percent" },
          ]}
          data={
            midData
          }
          options={{
            maxBodyHeight: '500px',
            headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
          }}
          title="MID Baselines Data"
        />
      </section>
    </div>
    // <section className="bg-back">

    // </section>
  )
}

export default MidBaselines